import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getSetupTasks = async () => {
  const response = await axiosInstance.get(`${API_URL}/setup-tasks`);
  return response.data;
};

export const completeSetupTask = async (taskKey) => {
  const response = await axiosInstance.post(`${API_URL}/setup-tasks`, { taskKey });
  return response.data;
};
